import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { TestResult } from '../../../../shared/models/test-result.model';
import { ManualNumberTestingService } from '../../../../shared/services/manual-number-testing.service';
import { PhoneReportUtils } from '../../../../shared/services/phone-report-utils';

type MntActionsComponentParams = ICellRendererParams & {
  getPhoneReportState: (row: TestResult) => ReturnType<typeof PhoneReportUtils.getPhoneReportState>;
  isAdmin: boolean;
};

@Component({
  standalone: false,
  selector: 'app-mnt-actions',
  templateUrl: './mnt-actions.component.html',
  styleUrls: ['./mnt-actions.component.scss'],
})
export class MntActionsComponent {
  constructor(private manualNumberTestingService: ManualNumberTestingService) {}

  currentRow: TestResult;
  showModem = true;
  phoneReportState: ReturnType<typeof PhoneReportUtils.getPhoneReportState> = null;

  agInit(params: MntActionsComponentParams): void {
    this.currentRow = params.data;
    this.showModem = !!params?.isAdmin;

    this.phoneReportState = params.getPhoneReportState(this.currentRow);
  }

  refresh(params: MntActionsComponentParams) {
    this.currentRow = params.data;
    this.showModem = !!params?.isAdmin;

    this.phoneReportState = params.getPhoneReportState(this.currentRow);

    return true;
  }

  onClick(clickedItem: string) {
    this.manualNumberTestingService.announceAction({ name: clickedItem, row: this.currentRow, column: 'action' });
  }

  onCreateReportClick() {
    if (this.phoneReportState.isAllowed) {
      return this.onClick('addPhoneNumberReport');
    }

    if (this.phoneReportState.canOpenReport) {
      return this.onClick('showPhoneNumberReport');
    }

    return null;
  }
}
